/**
 * How a creative's lifecycle stage is rendered.
 *
 * `UNATTRIBUTED` is not one of the four stages. It means the stage could not be
 * determined at all: `creative_id` is not populated on any performance
 * snapshot, so the lookup that derives a stage cannot match. Before the backend
 * returned it, that case silently returned "GROWING", which is why every
 * creative in the system read as GROWING — an unasked question rendered as a
 * finding (PERFORMANCE-GRAIN-AUDIT, CLAUDE.md rule 10).
 *
 * It must therefore never look like a stage. It reads as a plain statement and
 * is styled as an absence, not as a value.
 */
export const UNATTRIBUTED_STAGE = "UNATTRIBUTED";

export const UNATTRIBUTED_LABEL = "Not measurable — no creative attribution";

export const UNATTRIBUTED_TITLE =
  "Performance cannot be attributed to a specific creative: creative_id is " +
  "not populated on any performance_snapshots row. This is a known upstream " +
  "gap, not an absence of performance.";

export function isUnattributed(stage) {
  return stage === UNATTRIBUTED_STAGE;
}

/** Display text for a stage. Never invents one when the value is absent. */
export function lifecycleLabel(stage) {
  if (isUnattributed(stage)) return UNATTRIBUTED_LABEL;
  return stage || "N/A";
}

/** Tailwind classes. Unattributed is muted and italic — an absence, not a value. */
export function lifecycleClass(stage, valueClass = "text-white font-medium") {
  if (isUnattributed(stage)) return "text-amber-400/80 italic";
  return valueClass;
}

/** `title` attribute, so the reason is reachable without leaving the panel. */
export function lifecycleTitle(stage) {
  return isUnattributed(stage) ? UNATTRIBUTED_TITLE : undefined;
}
